<template>
  <div id="wrap">
    <Header />
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit">
        <h1>커뮤니티</h1>
      </div>

      <div class="hp_productMain_contentWrap">
        <div class="hp_productMain_contentSidebar">
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu">
              <li @click="setCommunityID(1)" :class="{ 'hp_productMain_contentMenu_active': 1 === statusData.communityID }">
                <a>공지사항</a>
              </li>
              <li @click="setCommunityID(2)" :class="{ 'hp_productMain_contentMenu_active': 2 === statusData.communityID }">
                <a>여행후기</a>
              </li>
              <li @click="setCommunityID(3)" :class="{ 'hp_productMain_contentMenu_active': 3 === statusData.communityID }">
                <a>온라인문의</a>
              </li>
              <li @click="setCommunityID(4)" :class="{ 'hp_productMain_contentMenu_active': 4 === statusData.communityID }">
                <a>자주 묻는 질문</a>
              </li>
              <li @click="setCommunityID(5)" :class="{ 'hp_productMain_contentMenu_active': 5 === statusData.communityID }">
                <a>단체여행문의</a>
              </li>
            </ul>
          </div>

          <!-- Hot Keywords -->
          <div class="hp_productMain_contentKeywordBox hp_MobNonePcBlock">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox">
              <p v-for="item in statusData.hotKeywordData" :key="item.hot_keyword_ID">
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <!-- 공지사항  -->
        <div class="hp_commuBody" v-if="statusData.communityID === 1">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            공지사항
          </div>
          <div class="hp_commuWrap">
            <!-- 검색 기능 -->
            <div class="hp_commu_searchBox">
              <input
                type="text"
                maxLength="20"
                v-model="statusData.noticeSearch"
                placeholder="검색어를 입력하세요"
                @keypress.enter="checkCommunityID(1)" />
              <button @click="checkCommunityID(1)">검색</button>
            </div>
            <!-- 게시물 테이블 - 모바일용-->
            <div class="hp_commu_listWrap hp_MobBlockPcNone">
              <div class="hp_commu_listBox_nodata" v-if="posts.length === 0">
                등록된 공지사항이 없습니다.
              </div>
              <div class="hp_commu_listBoxMob" v-else v-for="(post, index) in paginatedPosts" :key="index">
                <a :href="`/NoticeDetail?notice_ID=${post.notice_ID}`">
                  <div class="hp_commu_listBoxMob_top">
                    <div>
                      <p v-if="post.notice_top_status === 1" class="hp_commu_noticeBadge">
                        공지
                      </p>
                      <p v-else class="hp_MobNonePcBlock">
                        {{ post.notice_ID }}
                      </p>
                    </div>
                    <div>
                      {{ post.notice_title }}
                      <span class="hp_commu_commentNum" v-if="post.notice_comment_count > 0">
                        ({{ post.notice_comment_count }})
                      </span>
                    </div>
                  </div>
                  <div class="hp_commu_listDate">
                    {{ post.notice_registe }}
                  </div>
                </a>
              </div>
            </div>
            <!-- 게시물 테이블 - pc용-->
            <table class="hp_commu_listBoxPc hp_MobNonePcBlock"
              border="0" cellpadding="0" cellspacing="0" summary="공지사항">
              <caption>공지사항</caption>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>조회수</th>
                  <th>작성일</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="posts.length === 0">
                  <td colspan="4" class="hp_commu_listBox_nodata"> 등록된 공지사항이 없습니다.</td>
                </tr>
                <tr v-else v-for="(post, index) in paginatedPosts" :key="index">
                  <td>
                    <p v-if="post.notice_top_status === 1" class="hp_commu_noticeBadge">
                      공지
                    </p>
                    <p v-else>
                      {{ post.notice_ID }}
                    </p>
                  </td>
                  <td>
                    <a :href="`/NoticeDetail?notice_ID=${post.notice_ID}`">
                      {{ post.notice_title }}
                      <span class="hp_commu_commentNum" v-if="post.notice_comment_count > 0">
                        ({{ post.notice_comment_count }})
                      </span>
                    </a>
                  </td>
                  <td>{{ post.notice_views }}</td>
                  <td>{{ post.notice_registe }}</td>
                </tr>
              </tbody>
            </table>
            <!-- 페이지네이션 -->
            <div class="hp_commu_pagination">
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="goToFirstPage">
                <img src="../../../assets/images/icon/page_first.png" alt="First">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="prevPage">
                <img src="../../../assets/images/icon/page_prev.png" alt="Previous">
              </button>
              <!-- 5개의 페이지만 표시 -->
              <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
              </span>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="nextPage">
                <img src="../../../assets/images/icon/page_next.png" alt="Next">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="goToLastPage">
                <img src="../../../assets/images/icon/page_end.png" alt="Last">
              </button>
            </div>
          </div>
        </div>
        <!-- 공지사항  -->

        <!-- 여행후기  -->
        <div class="hp_commuBody" v-if="statusData.communityID === 2">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            여행후기
          </div>
          <div class="hp_commuWrap">
            <!-- 검색 기능 -->
            <div class="hp_commu_searchBox">
              <input
                type="text"
                maxLength="20"
                v-model="statusData.travelReviewSearch"
                placeholder="검색어를 입력하세요"
                @keypress.enter="checkCommunityID(2)" />
              <button @click="checkCommunityID(2)">검색</button>
            </div>
            <div class="hp_commu_postWrap">
              <div class="hp_commu_listBox_nodata" v-if="posts.length === 0">
                등록된 여행후기가 없습니다.
              </div>
              <div v-else v-for="(post, index) in paginatedPosts" :key="index" class="hp_commu_postBox">
                <a :href="`/TravelReviewDetail?travel_review_ID=${post.travel_review_ID}`">
                  <p class="hp_commu_postBox_img">
                    <img :src="post.travel_review_main_image" :alt="post.travel_review_title" />
                  </p>
                  <p v-if="post.travel_review_top_status === 1" class="hp_commu_postBox_noticeBadge">공지</p>
                  <p class="hp_commu_postBox_tit">{{ post.travel_review_title }}</p>
                </a>
              </div>
            </div>
            <!-- 페이지네이션 -->
            <div class="hp_commu_pagination">
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="goToFirstPage">
                <img src="../../../assets/images/icon/page_first.png" alt="First">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="prevPage">
                <img src="../../../assets/images/icon/page_prev.png" alt="Previous">
              </button>
              <!-- 5개의 페이지만 표시 -->
              <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
              </span>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="nextPage">
                <img src="../../../assets/images/icon/page_next.png" alt="Next">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="goToLastPage">
                <img src="../../../assets/images/icon/page_end.png" alt="Last">
              </button>
            </div>
            <div class="hp_commuDetail_BtnBox" v-if="sessionData.customer !== ''">
              <a href="/CommunityWrite?communityID=2">글쓰기</a>
            </div>
          </div>
        </div>
        <!-- 여행후기  -->

        <!-- 온라인문의  -->
        <div class="hp_commuBody" v-if="statusData.communityID === 3">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            온라인문의
          </div>
          <div class="hp_commuWrap">
            <!-- 검색 기능 -->
            <div class="hp_commu_searchBox">
              <input
                type="text"
                maxLength="20"
                v-model="statusData.onlineInquirySearch"
                placeholder="검색어를 입력하세요"
                @keypress.enter="checkCommunityID(3)" />
              <button @click="checkCommunityID(3)">검색</button>
            </div>
            <!-- 게시물 테이블 - 모바일용-->
            <div class="hp_commu_listWrap hp_MobBlockPcNone">
              <div class="hp_commu_listBox_nodata" v-if="posts.length === 0">
                등록된 온라인문의가 없습니다.
              </div>
              <div class="hp_commu_listBoxMob" v-else v-for="(post, index) in paginatedPosts" :key="index">
                <a @click="onlineInquiryJundgement(
                  post.online_inquiry_security_status,
                  post.customer_ID_use_online_inquiry,
                  post.online_inquiry_ID
                )">
                  <div class="hp_commu_listBoxMob_top">
                    <div>
                      <p v-if="post.online_inquiry_top_status === 1" class="hp_commu_noticeBadge">
                        공지
                      </p>
                      <p v-else class="hp_MobNonePcBlock">
                        {{ post.online_inquiry_ID }}
                      </p>
                    </div>
                    <div>
                      {{ post.online_inquiry_title }}
                      <span class="hp_commu_commentNum" v-if="post.online_inquiry_comment_count > 0">
                        ({{ post.online_inquiry_comment_count }})
                      </span>
                      <span class="hp_commu_commentIconLock" v-if="post.online_inquiry_security_status === 1">
                        <img src="../../../assets/images/icon/lock_icon.png" alt="자물쇠 아이콘" />
                      </span>
                    </div>
                  </div>
                  <div class="hp_commu_listDate">
                    {{ post.online_inquiry_registe }}
                  </div>
                </a>
              </div>
            </div>
            <!-- 게시물 테이블 - pc용-->
            <table class="hp_commu_listBoxPc hp_MobNonePcBlock"
              border="0" cellpadding="0" cellspacing="0" summary="온라인문의">
              <caption>온라인문의</caption>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>조회수</th>
                  <th>작성일</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="posts.length === 0">
                  <td colspan="4" class="hp_commu_listBox_nodata"> 등록된 온라인문의가 없습니다.</td>
                </tr>
                <tr v-else v-for="(post, index) in paginatedPosts" :key="index">
                  <td>
                    <p v-if="post.online_inquiry_top_status === 1" class="hp_commu_noticeBadge">
                      공지
                    </p>
                    <p v-else>
                      {{ post.online_inquiry_ID }}
                    </p>
                  </td>
                  <td>
                    <a @click="onlineInquiryJundgement(
                      post.online_inquiry_security_status,
                      post.customer_ID_use_online_inquiry,
                      post.online_inquiry_ID
                    )">
                      {{ post.online_inquiry_title }}
                      <span class="hp_commu_commentNum" v-if="post.online_inquiry_comment_count > 0">
                        ({{ post.online_inquiry_comment_count }})
                      </span>
                      <span class="hp_commu_commentIconLock" v-if="post.online_inquiry_security_status === 1">
                        <img src="../../../assets/images/icon/lock_icon.png" alt="자물쇠 아이콘" />
                      </span>
                    </a>
                  </td>
                  <td>{{ post.online_inquiry_views }}</td>
                  <td>{{ post.online_inquiry_registe }}</td>
                </tr>
              </tbody>
            </table>
            <!-- 페이지네이션 -->
            <div class="hp_commu_pagination">
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="goToFirstPage">
                <img src="../../../assets/images/icon/page_first.png" alt="First">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="prevPage">
                <img src="../../../assets/images/icon/page_prev.png" alt="Previous">
              </button>
              <!-- 5개의 페이지만 표시 -->
              <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
              </span>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="nextPage">
                <img src="../../../assets/images/icon/page_next.png" alt="Next">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="goToLastPage">
                <img src="../../../assets/images/icon/page_end.png" alt="Last">
              </button>
            </div>
            <div class="hp_commuDetail_BtnBox" v-if="sessionData.customer !== ''">
              <a href="/CommunityWrite?communityID=3">글쓰기</a>
            </div>
          </div>
        </div>
        <!-- 온라인문의  -->

        <!-- 자주 묻는 질문  -->
        <div class="hp_commuBody" v-if="statusData.communityID === 4">
          <div class="hp_mypageListWrapTit hp_MobNonePcBlock">
            자주 묻는 질문
          </div>
          <div class="hp_commuWrap">
            <!-- 검색 기능 -->
            <div class="hp_commu_searchBox">
              <input
                type="text"
                maxLength="20"
                v-model="statusData.frequentlyQuestionsSearch"
                placeholder="검색어를 입력하세요"
                @keypress.enter="checkCommunityID(4)" />
              <button @click="checkCommunityID(4)">검색</button>
            </div>
            <!-- 게시물 테이블 - 모바일용-->
            <div class="hp_commu_listWrap hp_MobBlockPcNone">
              <div class="hp_commu_listBox_nodata" v-if="posts.length === 0">
                등록된 자주 묻는 질문이 없습니다.
              </div>
              <div class="hp_commu_listBoxMob" v-else v-for="(post, index) in paginatedPosts" :key="index">
                <a :href="`/FrequentlyQuestionsDetail?frequently_questions_ID=${post.frequently_questions_ID}`">
                  <div class="hp_commu_listBoxMob_top">
                    <div>
                      <p v-if="post.frequently_questions_top_status === 1" class="hp_commu_noticeBadge">
                        공지
                      </p>
                      <p v-else class="hp_MobNonePcBlock">
                        {{ post.frequently_questions_ID }}
                      </p>
                    </div>
                    <div>
                      {{ post.frequently_questions_title }}
                      <span class="hp_commu_commentNum" v-if="post.frequently_questions_comment_count > 0">
                        ({{ post.frequently_questions_comment_count }})
                      </span>
                      <span class="hp_commu_commentIconLock" v-if="post.frequently_questions_security_status === 1">
                        <img src="../../../assets/images/icon/lock_icon.png" alt="자물쇠 아이콘" />
                      </span>
                    </div>
                  </div>
                  <div class="hp_commu_listDate">
                    {{ post.frequently_questions_registe }}
                  </div>
                </a>
              </div>
            </div>
            <!-- 게시물 테이블 - pc용-->
            <table class="hp_commu_listBoxPc hp_MobNonePcBlock"
              border="0" cellpadding="0" cellspacing="0" summary="자주 묻는 질문">
              <caption>자주 묻는 질문</caption>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>조회수</th>
                  <th>작성일</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="posts.length === 0">
                  <td colspan="4" class="hp_commu_listBox_nodata"> 등록된 자주 묻는 질문이 없습니다.</td>
                </tr>
                <tr v-else v-for="(post, index) in paginatedPosts" :key="index">
                  <td>
                    <p v-if="post.frequently_questions_top_status === 1" class="hp_commu_noticeBadge">
                      공지
                    </p>
                    <p v-else>
                      {{ post.frequently_questions_ID }}
                    </p>
                  </td>
                  <td>
                    <a :href="`/FrequentlyQuestionsDetail?frequently_questions_ID=${post.frequently_questions_ID}`">
                      {{ post.frequently_questions_title }}
                      <span class="hp_commu_commentNum" v-if="post.frequently_questions_comment_count > 0">
                        ({{ post.frequently_questions_comment_count }})
                      </span>
                      <span class="hp_commu_commentIconLock" v-if="post.frequently_questions_security_status === 1">
                        <img src="../../../assets/images/icon/lock_icon.png" alt="자물쇠 아이콘" />
                      </span>
                    </a>
                  </td>
                  <td>{{ post.frequently_questions_views }}</td>
                  <td>{{ post.frequently_questions_registe }}</td>
                </tr>
              </tbody>
            </table>
            <!-- 페이지네이션 -->
            <div class="hp_commu_pagination">
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="goToFirstPage">
                <img src="../../../assets/images/icon/page_first.png" alt="First">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage > 1" @click="prevPage">
                <img src="../../../assets/images/icon/page_prev.png" alt="Previous">
              </button>
              <!-- 5개의 페이지만 표시 -->
              <span v-for="page in visiblePages" :key="page" @click="goToPage(page)"
                :class="{ active: currentPage === page }">
                {{ page }}
              </span>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="nextPage">
                <img src="../../../assets/images/icon/page_next.png" alt="Next">
              </button>
              <button class="hp_commu_paginationBtn" v-if="currentPage < totalPages" @click="goToLastPage">
                <img src="../../../assets/images/icon/page_end.png" alt="Last">
              </button>
            </div>
          </div>
        </div>
        <!-- 자주 묻는 질문  -->

        <!-- 단체여행문의 -->
        <div class="hp_mypageListWrap" v-if="statusData.communityID === 5">
          <div class="hp_mypageListWrapTit">
            단체여행문의
          </div>
          <div class="hp_packageTop">
            <p>※ 회사 워크샵 / 야유회, 침목모임, 단체모임 등 10인이상 단체여행견적 및 상담을 도와드립니다.</p>
            <p>※ 자세한 단체여행 문의 시 고객센터 (02-3273-3311)로 연락 부탁드립니다.</p>
          </div>
          <div class="hp_mypagePoint_subTit">
            기본정보
          </div>
          <div class="hp_reservationBox">
            <table class="hp_tableForm hp_commuWriteTable" cellpadding="0" cellspacing="0" :summary="statusData.communityName">
              <caption>단체여행문의</caption>
              <colgroup>
                <col width="29%">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th>
                    <label for = 'group_inquiry_write'>문의자명 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'group_inquiry_write'
                      v-model="formData.groupInquiryWrite"
                      maxlength="10"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_phone_number'>휴대폰 번호 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'group_inquiry_phone_number'
                      v-model="formData.groupInquiryPhoneNumber"
                      @input="formatPhoneNumber"
                      maxlength="13"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_email'>이메일</label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'group_inquiry_email'
                      v-model="formData.groupInquiryEmail"
                      maxlength="50"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_expected_number'>예상인원 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_packageInputBox"
                      id = 'group_inquiry_expected_number'
                      v-model="formData.groupInquiryExpectedNumber"
                      @input="formatNumberInputWithComma('groupInquiryExpectedNumber', $event)"
                      >
                      <span class="hp_packageTxtSpan">명</span>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_start_date'>여행기간 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <p class="hp_packageDate">
                      <input
                        type = "date"
                        class="hp_packageInputBox packageFirst"
                        id = 'group_inquiry_start_date'
                        v-model="formData.groupInquiryStartDate"
                        max="2999-12-31"
                        >
                    </p>
                    <span class="hp_packageTxtSpan">&nbsp;~&nbsp;</span>
                    <p class="hp_packageDate">
                      <input
                        type = "date"
                        class="hp_packageInputBox packageLast"
                        id = 'group_inquiry_end_date'
                        v-model="formData.groupInquiryEndDate"
                        max="2999-12-31"
                        >
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_expected_expenses'>예상경비 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_packageInputBox"
                      id = 'group_inquiry_expected_expenses'
                      v-model="formData.groupInquiryExpectedExpenses"
                      @input="formatNumberInputWithComma('groupInquiryExpectedExpenses', $event)"
                      >
                      <span class="hp_packageTxtSpan">만원</span>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_desired_area'>희망지역 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'group_inquiry_desired_area'
                      v-model="formData.groupInquiryDesiredArea"
                      maxlength="10"
                    >
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'group_inquiry_word_advice'>남기실 말씀 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <textarea
                      id = 'group_inquiry_word_advice'
                      v-model="formData.groupInquiryWordAdvice"
                      :maxlength="250"
                      placeholder="남기실 말씀을 입력해주세요 (최대 250자)"
                      cols="120"
                      rows="6"
                      class="hp_packageTextarea">
                    </textarea>
                    <p class="hp_reservTextareaNum">{{ formData.groupInquiryWordAdvice.length }}/250</p>
                  </td>
                </tr>
                <tr>
                  <th>
                    <label for = 'security_code'>보안코드 <span class="pointTextRed">*</span></label>
                  </th>
                  <td>
                    <div class="securityTxt">{{statusData.securityCode}}</div>
                    <input
                      type = "text"
                      class="hp_tableInputBox"
                      id = 'security_code'
                      v-model="formData.securityCode"
                      maxlength="4"
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
            <div class="hp_commuDetail_pbAll">
              <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
              <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
                <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
              </div>
              <button type="button" @click="togglePopup(1)">약관보기</button>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
                <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
              </div>
              <button type="button" @click="togglePopup(2)">약관보기</button>
            </div>
            <div class="hp_commuDetail_pbEarch">
              <div>
                <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
                <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
              </div>
              <button type="button" @click="togglePopup(3)">약관보기</button>
            </div>
          </div>
          <!-- 모바일용 문의하기 버튼 : 클릭 시 예약 완료 페이지로 이동함 -->
          <div class="hp_reservation_btnReservMob">
            <button @click="handleGroupInquiry">문의하기</button>
          </div>
          <!-- PC용 문의하기, 취소하기 버튼 -->  <!-- 반응형할때 조절하기! -->
          <div class="hp_reservation_btnReservPc">
            <button class="hp_reservation_btnReservPc_on" @click="handleGroupInquiry">문의하기</button>
            <button>취소하기</button>
          </div>
        </div>
        <!-- 단체여행문의 -->

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_session_customer,
  get_hot_keyword_top10,
  get_notice_table,
  get_travel_review_table,
  get_online_inquiry_table,
  get_frequently_questions_table,
  insert_group_inquiry
} from '../../ETC/Axios.vue'

export default {
  name: 'Community',
  components: {
    Header,
    Footer,
    Scroll
  },
  data () {
    return {
      postsPerPage: 10,
      currentPage: 1,
      posts: [],
      statusData: {
        communityID: 1,
        hotKeywordData: [],
        noticeSearch: '',
        travelReviewSearch: '',
        onlineInquirySearch: '',
        frequentlyQuestionsSearch: '',
        securityCode: ''

      },
      sessionData: {
        customer: {
          customer_ID: 0
        }
      },
      formData: {
        groupInquiryWrite: '',
        groupInquiryPhoneNumber: '',
        groupInquiryEmail: '',
        groupInquiryExpectedNumber: '',
        groupInquiryExpectedExpenses: '',
        groupInquiryStartDate: '',
        groupInquiryEndDate: '',
        groupInquiryDesiredArea: '',
        groupInquiryWordAdvice: '',
        agreeAll: false,
        agree1: false,
        agree2: false,
        agree3: false,
        securityCode: ''
      }
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.posts.length / this.postsPerPage)
    },
    paginatedPosts () {
      const start = (this.currentPage - 1) * this.postsPerPage
      const end = start + this.postsPerPage
      return this.posts.slice(start, end)
    },
    visiblePages () {
      const pages = []
      let startPage = Math.max(1, this.currentPage - 2)
      let endPage = Math.min(this.totalPages, this.currentPage + 2)
      if (this.currentPage <= 3) {
        startPage = 1
        endPage = Math.min(5, this.totalPages)
      } else if (this.currentPage > this.totalPages - 2) {
        startPage = Math.max(1, this.totalPages - 4)
        endPage = this.totalPages
      }
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  methods: {
    handleGroupInquiry () {
      const nameRegex = /^[가-힣a-zA-Z]{2,}$/
      if (!this.formData.groupInquiryWrite) {
        alert('문의자명은 필수 입력 항목입니다.')
        return
      }
      if (!nameRegex.test(this.formData.groupInquiryWrite)) {
        alert('문의자명은 최소 2자리의 한글 또는 영문만 입력할 수 있습니다.')
        return
      }
      if (!this.formData.groupInquiryPhoneNumber) {
        alert('휴대폰 번호는 필수 입력 항목입니다.')
        return
      }
      const phoneRegex = /^\d{3}-\d{3,4}-\d{4}$/
      if (!phoneRegex.test(this.formData.groupInquiryPhoneNumber)) {
        alert('휴대폰 번호는 010-1234-5678 형식으로 입력해주세요.')
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (this.formData.groupInquiryEmail && !emailRegex.test(this.formData.groupInquiryEmail)) {
        alert('이메일 형식이 올바르지 않습니다.')
        return
      }
      if (!this.formData.groupInquiryExpectedNumber) {
        alert('예상인원은 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.groupInquiryStartDate || !this.formData.groupInquiryEndDate) {
        alert('여행기간은 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.groupInquiryExpectedExpenses) {
        alert('예상경비는 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.groupInquiryDesiredArea) {
        alert('희망지역은 필수 입력 항목입니다.')
        return
      }
      if (!this.formData.groupInquiryWordAdvice) {
        alert('남기실 말씀은 필수 입력 항목입니다.')
        return
      }
      if (this.formData.securityCode !== this.statusData.securityCode) {
        alert('보안 코드가 일치하지 않습니다.')
        return
      }
      if (!this.formData.agree1 || !this.formData.agree2 || !this.formData.agree3) {
        alert('모든 필수 동의 항목에 체크해주세요.')
        return
      }
      insert_group_inquiry(
        this.sessionData.customer.customer_ID,
        this.formData.groupInquiryWrite,
        this.formData.groupInquiryPhoneNumber,
        this.formData.groupInquiryEmail,
        this.formData.groupInquiryExpectedNumber.replace(/,/g, '').replace(/[^0-9]/g, ''),
        this.formData.groupInquiryStartDate,
        this.formData.groupInquiryEndDate,
        this.formData.groupInquiryExpectedExpenses.replace(/,/g, '').replace(/[^0-9]/g, ''),
        this.formData.groupInquiryDesiredArea,
        this.formData.groupInquiryWordAdvice
      ).then(result => {
        alert('단체여행문의 완료되었습니다. 담당 휴대폰 번호로 답변을 드리겠습니다.')
        window.location.href = `/Community?communityID=${this.statusData.communityID}`
      })
    },
    generateSecurityCode () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.statusData.securityCode = result
    },
    formatPhoneNumber (event) {
      let input = event.target.value.replace(/\D/g, '').substring(0, 11)
      let formatted = ''
      if (input.startsWith('010')) {
        if (input.length <= 3) {
          formatted = input
        } else if (input.length <= 7) {
          formatted = input.replace(/(\d{3})(\d{1,4})/, '$1-$2')
        } else {
          formatted = input.replace(/(\d{3})(\d{4})(\d{1,4})/, '$1-$2-$3')
        }
      } else {
        formatted = input.substring(0, 3)
      }
      this.formData.groupInquiryPhoneNumber = formatted
    },
    formatNumberInputWithComma (field, event) {
      const input = event.target.value
      const rawValue = input.replace(/,/g, '').replace(/[^0-9]/g, '')
      if (rawValue === '') {
        this.formData[field] = ''
      } else {
        const formattedValue = Number(rawValue).toLocaleString()
        this.formData[field] = formattedValue
        event.target.value = formattedValue
      }
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    prevPage () {
      if (this.currentPage > 1) this.currentPage--
    },
    nextPage () {
      if (this.currentPage < this.totalPages) this.currentPage++
    },
    goToPage (page) {
      this.currentPage = page
    },
    goToFirstPage () {
      this.currentPage = 1
    },
    goToLastPage () {
      this.currentPage = this.totalPages
    },
    checkCommunityID (id) {
      if (id === 1) {
        this.postsPerPage = 10
        this.currentPage = 1
        get_notice_table(this.statusData.noticeSearch).then(result => {
          this.posts = result
        })
      } else if (id === 2) {
        this.postsPerPage = 16
        this.currentPage = 1
        get_travel_review_table(this.statusData.travelReviewSearch).then(result => {
          this.posts = result
        })
      } else if (id === 3) {
        this.postsPerPage = 10
        this.currentPage = 1
        get_online_inquiry_table(this.statusData.onlineInquirySearch).then(result => {
          this.posts = result
        })
      } else if (id === 4) {
        this.postsPerPage = 10
        this.currentPage = 1
        get_frequently_questions_table(this.statusData.frequentlyQuestionsSearch).then(result => {
          this.posts = result
        })
      }
    },
    setCommunityID (id) {
      this.statusData.communityID = id
      this.checkCommunityID(id)
    },
    onlineInquiryJundgement (
      online_inquiry_security_status,
      customer_ID_use_online_inquiry,
      online_inquiry_ID) {
      if (online_inquiry_security_status === 0) {
        window.location.href = `/OnlineInquiryDetail?online_inquiry_ID=${online_inquiry_ID}`
      } else {
        if (customer_ID_use_online_inquiry !== this.sessionData.customer.customer_ID && this.sessionData.customer.customer_super_status !== 1) {
          alert('본인이 작성한 글만 확인할 수 있습니다.')
        } else {
          window.location.href = `/OnlineInquiryDetail?online_inquiry_ID=${online_inquiry_ID}`
        }
      }
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    get_session_customer().then(result_session => {
      this.sessionData.customer = result_session
      this.formData.groupInquiryWrite = result_session.customer_name
      this.formData.groupInquiryPhoneNumber = result_session.customer_phone_number
      this.formData.groupInquiryEmail = result_session.customer_email
    })
    if (this.$route.query.communityID !== undefined) {
      this.statusData.communityID = +this.$route.query.communityID
    }
    if (this.$route.query.noticeSearch !== undefined) {
      this.statusData.noticeSearch = this.$route.query.noticeSearch
    }
    if (this.$route.query.travelReviewSearch !== undefined) {
      this.statusData.travelReviewSearch = this.$route.query.travelReviewSearch
    }
    if (this.$route.query.onlineInquirySearch !== undefined) {
      this.statusData.onlineInquirySearch = this.$route.query.onlineInquirySearch
    }
    if (this.$route.query.frequentlyQuestionsSearch !== undefined) {
      this.statusData.frequentlyQuestionsSearch = this.$route.query.frequentlyQuestionsSearch
    }
    this.checkCommunityID(this.statusData.communityID)
    this.generateSecurityCode()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Community/Community.vue